namespace $.$$ {

	export class $shm_hitalama_map_widget_float_drawing extends $.$shm_hitalama_map_widget_float_drawing {

		drawing() {
			return this.widget().drawing()
		}

		lines() {
			return this.drawing().lines()
		}

		stroke_views() {
			return this.lines().map( ( _, index )=> this.Stroke( index ) )
		}

		content_pointerdown( event: PointerEvent ) {
			return $.$$.$shm_hitalama_map_widget_float.prototype.content_pointerdown.call( this, event )
		}

		draft() {
			return this.drawing().draft()
		}

		head_view() {
			return this.draft() ? [] : super.head_view()
		}

		outline() {
			return this.draft() ? [] : super.outline()
		}

		edges() {
			return this.draft() ? [] : super.edges()
		}

		toolbar() {
			return this.draft() ? [] : super.toolbar()
		}

		transition() {
			return 'none'
		}

		stroke_points( index: number ) {
			return this.lines()[ index ]?.points.map( point => point.join( ',' ) ).join( ' ' ) ?? ''
		}

		stroke_color( index: number ) {
			return this.lines()[ index ]?.color ?? this.drawing().color()
		}

		stroke_width( index: number ) {
			return String( this.lines()[ index ]?.width ?? this.drawing().width() )
		}

		view_box() {
			if( this.draft() ) {
				return `${ this.left() } ${ this.top() } ${ this.width() } ${ this.height() }`
			}

			const box = this.drawing().box()
			if( !box ) return `${ this.left() } ${ this.top() } ${ this.width() } ${ this.height() }`
			return `${ box.left } ${ box.top } ${ box.width } ${ box.height }`
		}

		line_width( next?: number ) {
			if( next !== undefined ) next = Math.max( 1, next )
			if( next !== undefined ) {
				this.drawing().lines( this.lines().map( line => ({ ... line, width: next }) ) )
			}
			return this.drawing().width( next )
		}

		line_color( next?: string ) {
			if( next !== undefined ) {
				this.drawing().lines( this.lines().map( line => ({ ... line, color: next }) ) )
			}
			return this.drawing().color( next )
		}

	}

}
